import { ProductsService } from './products';

export async function findAllManufacturersOfData (): Promise<any> {
    return ProductsService.findAllManufacturersOfData();
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/products/products.find-all-manufacturers-of-data.ts